var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContainer"},[_c('base-nav-my-exam'),_c('router-view'),_c('base-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }